import React from 'react';
import * as types from 'hellospa/page/prep-and-send/data/types';

const DeepIntegrationFinalLoadingForTemplate: types.WorkflowComponent = () => {
  return <div style={{ textAlign: 'center' }}>
    Taking you back to Dropbox.
  </div>;
};

DeepIntegrationFinalLoadingForTemplate.getText = () => {
  return {};
};

export default DeepIntegrationFinalLoadingForTemplate;
